// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tablegrid[data-v-c84a07f8]{border-collapse:collapse;width:100%}.tablegrid tr[data-v-c84a07f8]{border:1px solid #ddd}td[data-v-c84a07f8]{line-height:1.42857143;vertical-align:middle}td[data-v-c84a07f8]:not(:first-of-type){font-weight:700}td[data-v-c84a07f8]:nth-of-type(2){width:50%}tr td[data-v-c84a07f8]:first-of-type{width:50px}tr td:first-of-type .v-btn[data-v-c84a07f8]{min-width:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
